const defaultScreenOptions = {
    cardStyle: {
        overflow: 'visible',
        flex: 1,
    },
    headerShown: false,
    animationTypeForReplace: 'push',
};

export default defaultScreenOptions;
